import { PlaceSearchResult } from "@vahak/core/dist/custom-types/location-search";

export const LCV_ROUTE_CITIES = {
    ahmedabad: {
        city: "Ahmedabad",
        state: "Gujarat",
        description: "Ahmedabad, Gujarat, India",
        place_id: "ChIJSdRbuoqEXjkRFmVPYRHdzk8",
        state_id: 4
    },
    bangalore: {
        city: "Bangalore",
        state: "Karnataka",
        description: "Bangalore, Karnataka, India",
        place_id: "ChIJbU60yXAWrjsR4E9-UejD3_g",
        state_id: 3
    },
    chennai: {
        city: "Chennai",
        state: "Tamil Nadu",
        description: "Chennai, Tamil Nadu, India",
        place_id: "ChIJYTN9T-plUjoRM9RjaAunYW4",
        state_id: 6
    },
    delhi: {
        city: "Delhi",
        state: "Delhi",
        description: "Delhi, Delhi, India",
        place_id: "ChIJLbZ-NFv9DDkRzk0gTkm3wlI",
        state_id: 2
    },
    hyderabad: {
        city: "Hyderabad",
        state: "Telangana",
        description: "Hyderabad, Telangana, India",
        place_id: "ChIJx9Lr6tqZyzsRwvu6koO3k64",
        state_id: 5
    },
    jaipur: {
        city: "Jaipur",
        state: "Rajasthan",
        description: "Jaipur, Rajasthan, India",
        place_id: "ChIJgeJXTN9KbDkRCS7yDDrG4Qw",
        state_id: 8
    },
    kolkata: {
        city: "Kolkata",
        state: "West Bengal",
        description: "Kolkata, West Bengal, India",
        place_id: "ChIJ5093-p34AjoR-3pT1B1o9p4",
        state_id: 7
    },
    mumbai: {
        city: "Mumbai",
        state: "Maharashtra",
        description: "Mumbai, Maharashtra, India",
        place_id: "ChIJwe1EZjDG5zsRaYxkjY_tpF0",
        state_id: 1
    },
    pune: {
        city: "Pune",
        state: "Maharashtra",
        description: "Pune, Maharashtra, India",
        place_id: "ChIJARFGZy6_wjsRQ-Oenb9DjYI",
        state_id: 1
    }
} as Record<string, PlaceSearchResult>;
